'use strict';
var sleeknote = sleeknote || {};

sleeknote.anchorScroll = sleeknote.anchorScroll || function () {

	function init() {
		anchor_scroll();
	}

	function anchor_scroll() {
	    var anchor_link 	= document.querySelectorAll('a[href^="#"]');

	    for (var i = 0; i < anchor_link.length; i++) { 
	    	anchor_link[i].addEventListener('click', function(e) {
	    		e.preventDefault();

	    		var anchor_attr = this.getAttribute('href').replace('#', ''),
	    			elmnt_scroll_to = document.getElementById(anchor_attr),
	                scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
	                header_height = window.innerWidth > 991 ? 96 : 80,
	                elmnt_scrollTop = scrollTop + elmnt_scroll_to.getBoundingClientRect().top - (header_height + 48);

	    		window.scroll(0, elmnt_scrollTop);
	    	});
	    }
	}


	return {
		init : init
	};

}();